const setPublicOption = function (option, {title}) {
  option.title = {
    text: title,
    left: 'left',
    top: 20,
    textStyle: {
      color: '#ccc'
    }
  }
  option.toolbox = {
    feature: {
      dataView: {readOnly: false},
      restore: {},
      saveAsImage: {}
    }
  }
  option.grid = {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  }
}

const initOptionGauge = function () {
  let option = {}
  option.tooltip = {
    formatter: '{a} <br/>{b} : {c}%'
  }
  option.series = [{
    name: '业务指标',
    type: 'gauge',
    detail: {formatter: '{value}%'},
    data: [{value: 50, name: '完成率'}]
  }]
  return option
}

const initOptionFunnel = function () {
  let option = {}
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c}%'
  }
  option.legend = {
    data: []
  }
  option.calculable = true
  option.series = [{
    name: '漏斗图',
    type: 'funnel',
    left: '10%',
    top: 60,
    bottom: 60,
    width: '80%',
    min: 0,
    max: 700,
    minSize: '0%',
    maxSize: '100%',
    sort: 'descending',
    gap: 2,
    label: {
      normal: {
        show: true,
        position: 'inside'
      },
      emphasis: {
        textStyle: {
          fontSize: 20
        }
      }
    },
    labelLine: {
      normal: {
        length: 10,
        lineStyle: {
          width: 1,
          type: 'solid'
        }
      }
    },
    itemStyle: {
      normal: {
        borderColor: '#fff',
        borderWidth: 1
      }
    },
    data: []
  }]

  return option
}

const initOptionRadar = function () {
  let option = {}
  option.tooltip = {}
  option.legend = []
  option.radar = {
    indicator: []
  }
  option.series = [{
    name: 'asd',
    type: 'radar',
    data: []
  }]
  return option
}

const initOptionHuan = function () {
  let option = {}
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  }
  option.grid = {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  }
  option.legend = {
    orient: 'vertical',
    x: 'left',
    data: []
  }
  option.series = [{
    name: '看看看',
    type: 'pie',
    radius: ['50%', '70%'],
    data: [],
    label: {
      normal: {
        show: false,
        position: 'center'
      },
      emphasis: {
        show: true,
        textStyle: {
          fontSize: '30',
          fontWeight: 'bold'
        }
      }
    },
    labelLine: {
      normal: {
        lineStyle: {
          show: false
        }
      }
    }
  }]
  return option
}

const initOptionPie = function () {
  let option = {}
  option.backgroundColor = '#2c343c'
  option.tooltip = {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  }
  option.grid = {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  }
  option.xAxis = [{
    type: 'category',
    data: []
  }]
  option.yAxis = [{
    type: 'value'
  }]
  option.series = [{
    name: '看看看',
    type: 'pie',
    radius: '55%',
    center: ['50%', '50%'],
    data: [],
    roseType: 'radius',
    label: {
      normal: {
        textStyle: {
          color: 'rgba(255, 255, 255, 0.3)'
        }
      }
    },
    labelLine: {
      normal: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.3)'
        },
        smooth: 0.2,
        length: 10,
        length2: 20
      }
    },
    itemStyle: {
      normal: {
        color: '#c23531',
        shadowBlur: 200,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      }
    },
    animationType: 'scale',
    animationEasing: 'elasticOut',
    animationDelay: function (idx) {
      return Math.random() * 200
    }
  }]
  return option
}

const initOptionZzt = function () {
  let optionZzt = {}
  optionZzt.tooltip = {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  }
  optionZzt.legend = {data: []}
  optionZzt.xAxis = [{
    type: 'category',
    data: []
  }]
  optionZzt.yAxis = [{
    type: 'value'
  }]
  optionZzt.series = []
  return optionZzt
}

const buildOptionGauag = function (data, pageOption) {
  let newOption = initOptionGauge()
  return newOption
}

const buildOptionRadar = function (data) {
  let newOption = initOptionRadar()
  let seriesData = []
  let indicatorData = []
  data.dataZs.forEach(function (item) {
    let seriesDataOne = {value: data.dataYmap[item], name: item}
    seriesData.push(seriesDataOne)
  })
  data.dataXs.forEach(function (item) {
    indicatorData.push({name: item, max: (data.oterOption && data.oterOption.max ? data.oterOption.max : data.XmaxY[item] * 1.1)})
  })
  newOption.legend = {data: data.dataZs}
  newOption.radar.indicator = indicatorData
  newOption.series[0].data = seriesData
  return newOption
}

const buildOptionFunel = function (data) {
  let newOption = initOptionFunnel()
  let seriesData = []
  setPublicOption(newOption, {title: (data.oterOption && data.oterOption.title ? data.oterOption.title : '')})
  data.dataXs.forEach(function (item) {
    seriesData.push({name: item, value: data.dataYmap[item]})
  })
  newOption.legend.data = data.dataXs
  newOption.series[0].data = seriesData
  return newOption
}

const buildOptionPie = function (data) {
  let newOption = initOptionPie()
  let seriesData = []
  setPublicOption(newOption, {title: (data.oterOption && data.oterOption.title ? data.oterOption.title : '')})
  data.dataXs.forEach(function (item) {
    seriesData.push({name: item, value: data.dataYmap[item]})
  })
  newOption.series[0].data = seriesData
  return newOption
}

const buildOptionHuan = function (data) {
  let newOption = initOptionHuan()
  let seriesData = []
  setPublicOption(newOption, {title: (data.oterOption && data.oterOption.title ? data.oterOption.title : '')})
  data.dataXs.forEach(function (item) {
    seriesData.push({name: item, value: data.dataYmap[item]})
  })
  newOption.legend.data = data.dataXs
  newOption.series[0].data = seriesData
  return newOption
}

const buildOptionXy = function (data, type) {
  let newOption = initOptionZzt()
  let seriesData = []
  setPublicOption(newOption, {title: (data.oterOption && data.oterOption.title ? data.oterOption.title : '')})
  data.dataZs.forEach(function (item) {
    let seriesDataOne = {type: type, data: data.dataYmap[item], name: item}
    if (data.oterOption && data.oterOption.total) {
      seriesDataOne.stack = '总量'
    }
    seriesData.push(seriesDataOne)
  })
  newOption.legend = {data: data.dataZs}
  newOption.xAxis[0].data = data.dataXs
  newOption.series = seriesData
  return newOption
}

const buildOptionLine = function (data) {
  return buildOptionXy(data, 'line')
}

const buildOptionBar = function (data) {
  return buildOptionXy(data, 'bar')
}

const typeFun = {
  'line': buildOptionLine,
  'bar': buildOptionBar,
  'pie': buildOptionPie,
  'huan': buildOptionHuan,
  'radar': buildOptionRadar,
  'funnel': buildOptionFunel
}

export const initOption = function (data, pageOption) {
  if (pageOption.chartType === 'gauge') {
    return buildOptionGauag(data, pageOption)
  } else {
    let maxY = ['radar'].indexOf(pageOption.chartType) > -1
    let extractData = {}
    if (pageOption.dataZ) {
      extractData = extractXYZ({data: data, dataX: pageOption.dataX, maxY, dataY: pageOption.dataY, dataZ: pageOption.dataZ, oterOption: pageOption.oterOption})
    } else {
      extractData = extractXY({data: data, dataX: pageOption.dataX, maxY, dataY: pageOption.dataY, oterOption: pageOption.oterOption})
    }
    return typeFun[pageOption.chartType](extractData)
  }
}

export const extractXYZ = function ({data, dataX, dataY, dataZ, maxY = false, oterOption}) {
  let extractData = {dataXs: [], dataZs: [], dataYmap: {}, XmaxY: {}, oterOption: oterOption}
  let dataMap = []
  data.forEach(function (item) {
    let ZOne = item[dataZ]
    if (extractData.dataZs.indexOf(ZOne) === -1) {
      extractData.dataZs.push(ZOne)
    }
    let XOne = item[dataX]
    if (extractData.dataXs.indexOf(XOne) === -1) {
      extractData.dataXs.push(XOne)
    }
    dataMap[ZOne + '-' + XOne] = item[dataY]
    if (maxY) {
      extractData.XmaxY[XOne] = (typeof extractData.XmaxY[XOne] === 'undefined' ? Number(item[dataY]) : (extractData.XmaxY[XOne] > Number(item[dataY]) ? extractData.XmaxY[XOne] : Number(item[dataY])))
    }
  })
  extractData.dataZs.forEach(function (item) {
    extractData.dataYmap[item] = []
    extractData.dataXs.forEach(function (itemx) {
      extractData.dataYmap[item].push(dataMap[item + '-' + itemx])
    })
  })
  return extractData
}

export const extractXY = function ({data, dataX, dataY, maxY = false, oterOption}) {
  let extractData = {dataXs: [], dataYmap: {}, XmaxY: null, oterOption: oterOption}
  data.forEach(function (item) {
    let xOne = item[dataX]
    if (extractData.dataXs.indexOf(xOne) === -1) {
      extractData.dataXs.push(xOne)
    }
    extractData.dataYmap[xOne] = (extractData.dataYmap[xOne] ? extractData.dataYmap[xOne] + Number(item[dataY]) : Number(item[dataY]))
    if (maxY) {
      extractData.XmaxY = (extractData.XmaxY === null ? Number(item[dataY]) : (extractData.XmaxY > extractData.dataYmap[xOne] ? extractData.XmaxY : Number(extractData.dataYmap[xOne])))
    }
  })
  return extractData
}



// WEBPACK FOOTER //
// ./src/EchartsOptions.js